export const initStickyHeader = () => {
    const stickyWrapper = document.getElementById('sticky-wrapper');
    const mainNav = stickyWrapper.querySelector('.main-navigation.show-for-large');
    const mainNavSmall = stickyWrapper.querySelector('.main-navigation.hide-for-large');
    const companyHeader = document.querySelector('.company-header');
    const sentinel = document.getElementById('header-sentinel');
    const breadcrumbs = document.getElementById('breadcrumb-container');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                if (stickyWrapper) {
                    stickyWrapper.classList.add('fixed');
                }
                if (companyHeader) {
                    companyHeader.classList.add('fixed');
                }
                if (sentinel) {
                    sentinel.classList.add('fixed');
                }
                if (mainNav) {
                    mainNav.classList.add('fade-out');
                }
                if (mainNavSmall) {
                    mainNavSmall.classList.add('fade-out');
                }
                if (breadcrumbs) {
                    breadcrumbs.classList.add('scrolled');
                }
            } else {
                if (stickyWrapper) {
                    stickyWrapper.classList.remove('fixed');
                }
                if (companyHeader) {
                    companyHeader.classList.remove('fixed');
                }
                if (sentinel) {
                    sentinel.classList.remove('fixed');
                }
                if (mainNav) {
                    mainNav.classList.remove('fade-out');
                }
                if (mainNavSmall) {
                    mainNavSmall.classList.remove('fade-out');
                }
                if (breadcrumbs) {
                    breadcrumbs.classList.remove('scrolled');
                }
            }
        });
    }, {
        root: null,
        threshold: 0
    });
    observer.observe(sentinel);
};
